import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CNPrescription } from 'src/app/models/cnprescription';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import * as moment from 'moment';

@Component({
  selector: 'app-prescription-edit',
  templateUrl: './prescription-edit.component.html',
  styleUrls: ['./prescription-edit.component.scss']
})
export class PrescriptionEditComponent implements OnInit {

  private entryToEdit: CNPrescriptionEntry;

  startdate = new UntypedFormControl();
  enddate = new UntypedFormControl();

  constructor() { }

  ngOnInit(): void {
  }

  @Input() set entry(theEntry: CNPrescriptionEntry) {
    console.log('the entry', theEntry);
    this.entryToEdit = theEntry;
    this.startdate.setValue(this.entryToEdit.getProperty('StartDate'));
    this.enddate.setValue(this.entryToEdit.getProperty('EndDate'));
  }

  get entry() {
    return this.entryToEdit;
  }
}
